interface Props {
  children?: any;
}

export const AuthLayout = ({ children }: Props) => {
  return <div>{children}</div>;
};
